var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appsContainer"},_vm._l((_vm.apps),function(app){return _c('App',{key:app.key,attrs:{"app":app,"showname":true},nativeOn:{"click":function($event){return _vm.goToOtherApp(app)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }